<mat-card>
    <mat-card-title>
        <h2>Roles Settings</h2>
    </mat-card-title>
    <mat-card-subtitle
        >Here you can update the settings for your roles & manage access
        levels.</mat-card-subtitle
    >

    <mat-card-content>
        <div class="row">
            <div class="col-12">
                <h3 class="custom-spacing">Default Roles</h3>
                <mat-card-subtitle>Default roles can be modified but cannot be removed from the system.</mat-card-subtitle>

                <!-- <pre>{{default_roles.data | json}}</pre> -->
                <table mat-table [dataSource]="default_roles" class="w-100">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let role">{{ role.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="permissions_count">
                        <th mat-header-cell *matHeaderCellDef>
                            Permission Count
                        </th>
                        <td mat-cell *matCellDef="let role">
                            {{ role.permissions_count }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="user_count">
                        <th mat-header-cell *matHeaderCellDef>User Count</th>
                        <td mat-cell *matCellDef="let role">
                            {{ role.users_count }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let role">
                            <a
                                mat-button
                                (click)="editRole(role)"
                                *appCan="'edit_roles'"
                                >Edit</a
                            >&nbsp;&nbsp;
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                    <tr class="mat-row" *matNoDataRow>
                        @if (!default_roles.data) {
                        <td
                            class="mat-cell"
                            colspan="9999"
                            style="text-align: center;"
                        >
                            <i>No default roles were found...</i>
                        </td>
                        }
                    </tr>

                    <tfoot>
                        <mat-paginator
                            [length]="default_roles_total_rows"
                            [pageIndex]="default_roles_current_page"
                            [pageSize]="default_roles_page_size"
                            [pageSizeOptions]="pageSizeOptions"
                            aria-label="Select page"
                            showFirstLastButtons
                        >
                        </mat-paginator>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h3 class="custom-spacing">Custom Roles</h3>
                <button
                    mat-raised-button
                    *appCan="'add_roles'"
                    color="primary"
                    class="button-position"
                    (click)="createRole()"
                >
                    Create Role
                </button>
                <mat-card-subtitle>Custom roles can be created and modified by you.</mat-card-subtitle>

                <table mat-table [dataSource]="custom_roles" class="w-100">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let role">{{ role.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="permissions_count">
                        <th mat-header-cell *matHeaderCellDef>
                            Permission Count
                        </th>
                        <td mat-cell *matCellDef="let role">
                            {{ role.permissions_count }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="user_count">
                        <th mat-header-cell *matHeaderCellDef>User Count</th>
                        <td mat-cell *matCellDef="let role">
                            {{ role.users_count }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let role">
                            <a mat-button (click)="editRole(role)" *appCan="'edit_roles'">Edit</a>

                            <button mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="onDelete(role.id)" *appCan="'delete_roles'">Delete</button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                    <tr class="mat-row" *matNoDataRow>
                        @if (!custom_roles.data) {
                        <td
                            class="mat-cell"
                            colspan="9999"
                            style="text-align: center;"
                        >
                            <i>No custom roles were found...</i>
                        </td>
                        }
                    </tr>

                    <tfoot>
                        <mat-paginator
                            [length]="custom_roles_total_rows"
                            [pageIndex]="custom_roles_current_page"
                            [pageSize]="custom_roles_page_size"
                            [pageSizeOptions]="pageSizeOptions"
                            aria-label="Select page"
                            showFirstLastButtons
                        >
                        </mat-paginator>
                    </tfoot>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<div class="centered-tour-element" tourAnchor="settings.roles.list"></div>
